import { visitorNotificationSettingDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const settingSchema = dataEnvelopeSchema(visitorNotificationSettingDTOSchema);
const SETTINGS_PATH = `${WEB_API_PREFIX}/visitor/notification-settings`;
export function createNotificationSettingsResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({ path: SETTINGS_PATH, schema: settingSchema });
            return envelope.data;
        },
        async update(input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: SETTINGS_PATH,
                schema: settingSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=notification-settings.js.map